import { faClipboard } from '@fortawesome/pro-light-svg-icons/faClipboard';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { IconProp } from '@benzinga/core-ui';

export interface ShareData {
  text: string;
  title?: string;
  url?: string;
}

export interface ShareTargets {
  icon: IconProp;
  label: string;
  name: ShareActionName;
}

export type ShareActionName = 'Copy' | 'Twitter' | 'Facebook' | 'Email';

export const toggleShareView = async (shareData: ShareData, toggle: () => void) => {
  const isMobile =
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
      ? true
      : false;

  if (isMobile) {
    try {
      await navigator.share(shareData);
    } catch (error) {
      console.error(error);
    }
  } else toggle();
};

export const shareTargets: ShareTargets[] = [
  { icon: faClipboard, label: 'Copy Post URL', name: 'Copy' },
  { icon: faFacebook, label: 'Share to Facebook', name: 'Facebook' },
  { icon: faTwitter, label: 'Share to Twitter', name: 'Twitter' },
  { icon: faEnvelope, label: 'Share to Email', name: 'Email' },
];
